import { render } from "./SupplierReturnEditView.vue?vue&type=template&id=0381dd81&scoped=true"
import script from "./SupplierReturnEditView.vue?vue&type=script&lang=js"
export * from "./SupplierReturnEditView.vue?vue&type=script&lang=js"

import "./SupplierReturnEditView.vue?vue&type=style&index=0&id=0381dd81&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0381dd81"]])

export default __exports__